import { useEffect, useState } from "react";

import moment from "moment";

import { Button } from "primereact/button";

import { RegisterInvoiceService } from "../../../service/invoice/RegisterInvoiceService";
import { InvoiceService } from "../../hoa-don/InvoiceService";
import { IntegratedReportService as Service } from "./IntegratedReportService";

import cookie from "cookiejs";
import { ToastService } from "../../../AppToast";
import {
  createJob,
  ERROR,
  getCurrentJob,
  getDetailJobById,
  IN_PROGRESS,
  INTEGRATED_REPORT,
  loginJob,
  SUCCESS,
} from "../../../service/ExportService";
import { useForm } from "../../../shared/hooks/Form";
import { checkLoginRequired } from "../../../utils/helperExportExcel";
import { useDialogExportContext } from "../../context/DialogExportContext";
import { LoadingService } from "../../../AppLoading";
import { getReportPeriodOptions } from "../reportFilterOptions";
import { localized, useTranslation } from "../../../shared/language";

export default function NhanPmkt() {
  const { t } = useTranslation();
  const periods = getReportPeriodOptions(t);
  const [registerInvoices, setRegisterInvoices] = useState([]);
  const [vendors, setVendors] = useState([]);

  const { setVisible, setStatus, setJobDetail, setMinimize, status } = useDialogExportContext();

  useEffect(() => {
    RegisterInvoiceService.getUsingList({ maxResultCount: 1000 }).then(
      ({ items }) => {
        const _registerInvoices = [];
        items.forEach((item) => {
          _registerInvoices.push({
            value: item.symbolCode,
            label: item.symbolCode,
          });
        });
        setRegisterInvoices(_registerInvoices);
      }
    );

    Service.getVendors().then(({ items }) => {
      const _vendors = [];
      items.forEach((item) => {
        _vendors.push({ value: item.code, label: item.name });
      });
      setVendors(_vendors);
    });
  }, []);

  useEffect(() => {
    if (vendors && vendors.length) {
      const _value = getValue();
      _value.period = "THISMONTH";
      _value.invoiceStatus = [0, 2, 3, 4, 5];
      _value.sendTaxStatus = [4];
      _value.vendorCode = vendors[0].value;
      setValue(_value);
    }
  }, [vendors]); // eslint-disable-line react-hooks/exhaustive-deps

  const {
    render: renderForm,
    getValue,
    setValue,
  } = useForm({
    fields: [
      {
        field: "period",
        header: t("report.choosePeriod"),
        type: "Dropdown",
        DropdownProps: { options: periods },
        className: "md:col-4",
        labelClassName: "md:col-4",
        inputClassName: "md:col-8",
      },
      {
        field: "fromDate",
        header: t("common.fromDate"),
        type: "Calendar",
        className: "md:col-4",
        labelClassName: "md:col-4",
        inputClassName: "md:col-8",
      },
      {
        field: "toDate",
        header: t("common.toDate"),
        type: "Calendar",
        className: "md:col-4",
        labelClassName: "md:col-4",
        inputClassName: "md:col-8",
      },
      {
        field: "symbol",
        header: t("common.symbol"),
        type: "MultiSelect",
        MultiSelectProps: { options: registerInvoices, filter: true },
        className: "md:col-4",
        labelClassName: "md:col-4",
        inputClassName: "md:col-8",
      },
      {
        field: "invoiceStatus",
        header: t("common.status"),
        type: "MultiSelect",
        MultiSelectProps: {
          options: InvoiceService.invoiceStatuses,
          filter: true,
        },
        className: "md:col-4",
        labelClassName: "md:col-4",
        inputClassName: "md:col-8",
      },
      {
        field: "sendTaxStatus",
        header: t("common.submissionStatus"),
        type: "MultiSelect",
        MultiSelectProps: {
          options: InvoiceService.sendTaxStatuses,
          filter: true,
        },
        className: "md:col-4",
        labelClassName: "md:col-4",
        inputClassName: "md:col-8",
      },
      {
        field: "vendorCode",
        header: t("report.accountingSoftware"),
        type: "Dropdown",
        DropdownProps: { options: vendors },
        className: "md:col-4",
        labelClassName: "md:col-4",
        inputClassName: "md:col-8",
      },
    ],
    layout: "Horizontal",
  });

  const { period } = getValue();
  useEffect(() => {
    if (period) {
      let fromDate = new Date(),
        toDate = new Date();

      const months = [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ];
      const quarters = [
        "FISCALQUARTER1",
        "FISCALQUARTER2",
        "FISCALQUARTER3",
        "FISCALQUARTER4",
      ];
      if (period && months.indexOf(period) >= 0) {
        fromDate = moment()
          .month(months.indexOf(period))
          .startOf("month")
          .toDate();
        toDate = moment().month(months.indexOf(period)).endOf("month").toDate();
      } else if (period && quarters.indexOf(period) >= 0) {
        fromDate = moment()
          .quarter(quarters.indexOf(period) + 1)
          .startOf("quarter")
          .toDate();
        toDate = moment()
          .quarter(quarters.indexOf(period) + 1)
          .endOf("quarter")
          .toDate();
      } else {
        switch (period) {
          case "TODAY":
            fromDate = moment().startOf("day").toDate();
            toDate = moment().endOf("day").toDate();
            break;
          case "THISWEEK":
            fromDate = moment().startOf("isoWeek").toDate();
            toDate = moment().endOf("isoWeek").toDate();
            break;
          case "THISWEEKTODATE":
            fromDate = moment().startOf("isoWeek").toDate();
            break;
          case "THISMONTH":
            fromDate = moment().startOf("month").toDate();
            toDate = moment().endOf("month").toDate();
            break;
          case "THISMONTHTODATE":
            fromDate = moment().startOf("month").toDate();
            break;
          case "THISFISCALQUARTER":
            fromDate = moment().startOf("quarter").toDate();
            toDate = moment().endOf("quarter").toDate();
            break;
          case "THISFISCALQUARTERTODATE":
            fromDate = moment().startOf("quarter").toDate();
            break;
          case "THISFISCALYEAR":
            fromDate = moment().startOf("year").toDate();
            toDate = moment().endOf("year").toDate();
            break;
          case "THISFISCALYEARTODATE":
            fromDate = moment().startOf("year").toDate();
            break;
          case "FIRSTSIXMONTH":
            fromDate = moment().startOf("year").toDate();
            toDate = moment().month(5).endOf("month").toDate();
            break;
          case "LASTSIXMONTH":
            fromDate = moment().month(6).startOf("month").toDate();
            toDate = moment().endOf("year").toDate();
            break;
          case "YESTERDAY":
            fromDate = moment().subtract(1, "day").startOf("day").toDate();
            toDate = moment().subtract(1, "day").endOf("day").toDate();
            break;
          case "LASTWEEK":
            fromDate = moment().subtract(1, "week").startOf("isoWeek").toDate();
            toDate = moment().subtract(1, "week").endOf("isoWeek").toDate();
            break;
          case "LASTMONTH":
            fromDate = moment().subtract(1, "month").startOf("month").toDate();
            toDate = moment().subtract(1, "month").endOf("month").toDate();
            break;
          case "LASTFISCALQUARTER":
            fromDate = moment()
              .subtract(1, "quarter")
              .startOf("quarter")
              .toDate();
            toDate = moment().subtract(1, "quarter").endOf("quarter").toDate();
            break;
          case "LASTFISCALYEAR":
            fromDate = moment().subtract(1, "year").startOf("year").toDate();
            toDate = moment().subtract(1, "year").endOf("year").toDate();
            break;
          case "NEXTWEEK":
            fromDate = moment().add(1, "week").startOf("isoWeek").toDate();
            toDate = moment().add(1, "week").endOf("isoWeek").toDate();
            break;
          case "NEXTMONTH":
            fromDate = moment().add(1, "month").startOf("month").toDate();
            toDate = moment().add(1, "month").endOf("month").toDate();
            break;
          case "NEXTFISCALQUARTER":
            fromDate = moment().add(1, "quarter").startOf("quarter").toDate();
            toDate = moment().add(1, "quarter").endOf("quarter").toDate();
            break;
          case "NEXTFISCALYEAR":
            fromDate = moment().add(1, "year").startOf("year").toDate();
            toDate = moment().add(1, "year").endOf("year").toDate();
            break;
        }
      }
      const _value = getValue();
      _value.fromDate = fromDate;
      _value.toDate = toDate;
      setValue(_value);
    }
  }, [period]); // eslint-disable-line react-hooks/exhaustive-deps

  const apply = () => {
    const _value = getValue();
    if (_value.symbol) {
      _value.symbol = _value.symbol.join(",");
    }

    if (_value.invoiceStatus) {
      _value.invoiceStatus = _value.invoiceStatus.join(",");
    }

    if (_value.sendTaxStatus) {
      _value.sendTaxStatus = _value.sendTaxStatus.join(",");
    }

    Service.downloadExcel(_value).then((data) => {
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(new Blob([data]));
      link.download = `nhan-pmkt.xlsx`;
      link.click();
    });
  };

  const TENNANT_ID = localStorage.getItem("iam-m-invoice-react.v1.0.0_tenant");

  const getDetailJobRunning = async (id: string) => {
    const res = await getDetailJobById(id);
    setJobDetail(res);
    const isExpired = res.expiredTime && new Date(res.expiredTime) < new Date();

    if (res.status === IN_PROGRESS && isExpired) {
      setStatus("error");
      setVisible(true);
      return;
    }

    if (res.status === IN_PROGRESS) {
      setStatus("doing");
      setVisible(true);
      setTimeout(() => {
        getDetailJobRunning(id);
      }, 3000);
    }

    if (res.status === SUCCESS) {
      setStatus("success");
      setVisible(true);
    }
    if (res.status === ERROR) {
      setStatus("error");
      setVisible(true);
    }
  };

  const handleExportExcel = async () => {
    const accessToken = cookie.get("access_token_report");
    const refreshExpiredAtString = cookie.get("refreshExpiredAt");

    const isLoginRequired = checkLoginRequired(
      accessToken,
      refreshExpiredAtString
    );

    if (isLoginRequired) {
      await loginJob();
    }
    let resCurrent = await getCurrentJob();

    const runningJobs = resCurrent.filter(
      (job: any) => job.status === IN_PROGRESS
    );

    const _value = getValue();
    if (_value.symbol) {
      _value.symbol = _value.symbol.join(",");
    }

    if (_value.invoiceStatus) {
      _value.invoiceStatus = _value.invoiceStatus.join(",");
    }

    if (_value.sendTaxStatus) {
      _value.sendTaxStatus = _value.sendTaxStatus.join(",");
    }

    if (status === "doing") {
      return ToastService.error(localized("common.exportRunningMessage"));
    }
    if (runningJobs?.length === 0) {
      await createJob(INTEGRATED_REPORT, _value);
      setJobDetail(null);
      setVisible(true);
      resCurrent = await getCurrentJob();
    } else {
      return ToastService.error(localized("common.exportRunningMessage"));
    }

    if (resCurrent.length === 0) {
      setStatus("doing");
      return;
    }

    const jobToTrack = resCurrent.find((job: any) => job.status === IN_PROGRESS) || resCurrent[0];
    setJobDetail(jobToTrack);

    const res = await getDetailJobById(jobToTrack?.jobId!);
    localStorage.setItem("jobIdRunning", jobToTrack?.jobId!);

    switch (res.status) {
      case IN_PROGRESS:
        setStatus("doing");
        break;
      case SUCCESS:
        setStatus("success");
        break;
      case ERROR:
        setStatus("error");
        break;
    }

    if (res.status === SUCCESS) {
      setJobDetail(res);
    }

    if (res.status === IN_PROGRESS) {
      setMinimize(false);
      getDetailJobRunning(jobToTrack?.jobId!);
      LoadingService.stop()
    }

    setVisible(true);
  };

  return (
    <div className="card">
      {renderForm()}

      <div className="flex">
        {/* <Button label="Kết xuất" icon="pi pi-file-excel" onClick={apply} /> */}
        <Button onClick={handleExportExcel}>{t("report.exportExcel")}</Button>
      </div>
    </div>
  );
}
